import script from "./historyOrCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./historyOrCollection.vue?vue&type=script&lang=ts&setup=true"

import "./historyOrCollection.vue?vue&type=style&index=0&id=6f64f549&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f64f549"]])

export default __exports__